import { render, staticRenderFns } from "./ServiceAgreement.vue?vue&type=template&id=fa8e8586&scoped=true&"
var script = {}
import style0 from "./ServiceAgreement.vue?vue&type=style&index=0&id=fa8e8586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8e8586",
  null
  
)

export default component.exports